import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import { ExperimentResourcesBase } from "./ExperimentResourcesBase.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentForProgressionResources = class extends ExperimentResourcesBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy);
  }
};
ExperimentForProgressionResources = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], ExperimentForProgressionResources);
const ExperimentResourcesForProgression = new ExperimentForProgressionResources();
export {
  ExperimentForProgressionResources,
  ExperimentResourcesForProgression as default
};
//# sourceMappingURL=ExperimentResourcesForProgression.js.map
